import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { EvoPayCardData } from '../../types/types';
import { Service } from '../../service';
import './creditCard.css';

export interface CreditCardRef {
    tokenize: () => Promise<EvoPayCardData>;
}

interface CreditCardFormProps {
    branch: string;
}

const EVO_PAY_SDK_URL = 'https://w12evopay.com/evocartao/evo-pay.js';

const initComponent = async () => {
    if (!Service.branch) {
        return;
    }
    const el = document.querySelector('evo-cartao') as any;
    if (!el) return;

    const [gateway, bandeiras] = await Promise.all([
        Service.getGatewayConfig(),
        Service.getCardFlags(),
        // Service.getCardTranslations(),
    ]);

    // Branch inválida faz a API devolver { code, message } em vez dos dados, e o SDK
    // do EVO Pay lança exceção ao tentar iterar as bandeiras.
    if (!gateway || gateway.code || !Array.isArray(bandeiras)) {
        return;
    }

    el.classes = 'form-no-style';
    el.gateway = gateway;
    el.bandeiras = bandeiras;
    // el.traducoes = traducoes;
};

const CreditCardForm = forwardRef<CreditCardRef, CreditCardFormProps>(({ branch }, ref) => {
    useEffect(() => {
        if (!branch) {
            return;
        }

        // Sem o cancelamento, o duplo mount do StrictMode (dev) dispara initComponent
        // duas vezes e duplica as chamadas de gateway/card-flags.
        let cancelled = false;
        let timer: ReturnType<typeof setTimeout> | undefined;
        const schedule = () => {
            timer = setTimeout(() => {
                if (!cancelled) {
                    initComponent();
                }
            }, 500);
        };

        const existing = document.querySelector<HTMLScriptElement>(`script[src="${EVO_PAY_SDK_URL}"]`);
        if (existing) {
            schedule();
        } else {
            const script = document.createElement('script');
            script.src = EVO_PAY_SDK_URL;
            script.onload = schedule;
            document.head.appendChild(script);
        }

        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [branch]);

    useImperativeHandle(ref, () => ({
        tokenize: () =>
            new Promise<EvoPayCardData>((resolve, reject) => {
                const el = document.querySelector('evo-cartao');
                if (!el) {
                    reject('Componente de cartão não encontrado');
                    return;
                }
                const onToken = (e: Event) => {
                    el.removeEventListener('eventoTokenGerado', onToken);
                    el.removeEventListener('eventoOcorreuErro', onError);
                    resolve((e as CustomEvent).detail as EvoPayCardData);
                };
                const onError = (e: Event) => {
                    el.removeEventListener('eventoTokenGerado', onToken);
                    el.removeEventListener('eventoOcorreuErro', onError);
                    reject((e as CustomEvent).detail);
                };
                el.addEventListener('eventoTokenGerado', onToken);
                el.addEventListener('eventoOcorreuErro', onError);
                el.dispatchEvent(new CustomEvent('salvar'));
            }),
    }));

    return React.createElement('evo-cartao');
});

export default CreditCardForm;
